<template>
  <!-- 有暗码 -->
  <div v-if="isCryptogram">
    <div class="container" v-if="isShow">
      <section class="section">
        <p class="important_font">若您已经购买本产品</p><p class="small_font">请输入6位验证码</p>
        <div class="input_box">
          <input 
            class="papaCode" 
            type="number" 
            inputmode="numeric"
            maxlength="1"
            pattern="[0-9]*"
            v-for="(item, index) in numbers"
            :key="index" :value="numbers[index]"
            @input="inputHandler($event,index)"
            @keydown.delete="deleteHandler($event,index)"
          />
        </div>
      </section>
      <section class="btn_section">
        <a class="btn_black_again code_submit" @click="submit">正品验证</a>
      </section>
    </div>
    <template v-else>
      <template v-if="isCorrect">
        <div class="result_container" v-if="resultData.quantity > companyData.scanCodeTimes">
          <div class="result_section">
            <a class="btn_black" style="margin-top: 10px;">
              防伪查询：<br>
              <p>您好，您所查询的防伪码当前为第<span>{{ resultData.quantity }}</span>次查询，请谨防假冒!如有疑问；请联系厂家。</p>
            </a>
            <template v-if="proData.shareFileList">
              <div v-for="(item,index) in proData.shareFileList" :key="index" class="pro-img">
                <img :src="item.fileUrl" alt="" width="100%" />
              </div>
            </template>
            <div class="pro_info" v-if="proData.productName">
              产品名称：{{ proData.productName ? proData.productName : '暂无' }}
            </div>
            <div class="pro_info" v-if="proData.specifications">
              产品规格：{{ proData.specifications ? proData.specifications : '暂无' }}
            </div>
            <div class="pro_info" v-if="companyData.name">
              公司名称：{{ companyData.name ? companyData.name : '暂无' }}
            </div>
            <div class="pro_info" v-if="companyData.manufacturer">
              生产厂家：{{ companyData.manufacturer ? companyData.manufacturer : '暂无' }}
            </div>
            <div class="pro_info" v-if="companyData.client">
              委托方：{{ companyData.client ? companyData.client : '暂无' }}
            </div>
            <a class="btn_black_again" @click="onAgain">再次输入</a>
          </div>
        </div>
        <div v-else class="result_container">
          <div class="result_section">
            <a class="btn_black" style="margin-top: 10px;">
              防伪查询：<br>
              <p>该产品为官方正品，已查询<span>{{ resultData.quantity }}</span>次；请放心使用，感谢您的支持！</p>
            </a>
            <template v-if="proData.shareFileList">
              <div v-for="(item,index) in proData.shareFileList" :key="index" class="pro-img">
                <img :src="item.fileUrl" alt="" width="100%" />
              </div>
            </template>
            <div class="pro_info" v-if="proData.productName">
              产品名称：{{ proData.productName ? proData.productName : '暂无' }}
            </div>
            <div class="pro_info" v-if="proData.specifications">
              产品规格：{{ proData.specifications ? proData.specifications : '暂无' }}
            </div>
            <div class="pro_info" v-if="companyData.name">
              公司名称：{{ companyData.name ? companyData.name : '暂无' }}
            </div>
            <div class="pro_info" v-if="companyData.manufacturer">
              生产厂家：{{ companyData.manufacturer ? companyData.manufacturer : '暂无' }}
            </div>
            <div class="pro_info" v-if="companyData.client">
              委托方：{{ companyData.client ? companyData.client : '暂无' }}
            </div>
          </div>
        </div>
      </template>
      <div class="result_container" v-else>
        <div class="result_section">
          <div class="table">
            <img src="../assets/imgs/error.jpg" alt="" width="150" />
          </div>
          <div class="content">
            <p class="important_font">未匹配到信息</p>
            <p class="gray_font">请输入正确的6位验证</p>
          </div>
          <a class="btn_black_again" @click="onAgain">再次输入</a>
        </div>
      </div>
    </template>
    <div v-if="load" class="loading">
      <img src="../assets/imgs/loading.gif" alt="" width="150" />
      <!-- Loading -->
    </div>
  </div>
  <!-- 无暗码 -->
  <div v-else>
    <div v-if="load" class="loading">
      <img src="../assets/imgs/loading.gif" alt="" width="150" />
      <!-- Loading -->
    </div>
    <div class="result_container">
      <div class="result_section">
        <a class="btn_black" style="margin-top: 10px;" v-if="resultData.quantity > companyData.scanCodeTimes">
          防伪查询：<br>
          <p>您好，您所查询的防伪码当前为第<span>{{ resultData.quantity }}</span>次查询，请谨防假冒!如有疑问；请联系厂家。</p>
        </a>
        <a class="btn_black" style="margin-top: 10px;" v-else>
          防伪查询：<br>
          <p>该产品为官方正品，已查询<span>{{ resultData.quantity }}</span>次；请放心使用，感谢您的支持！</p>
        </a>
        <template v-if="proData.shareFileList">
          <div v-for="(item,index) in proData.shareFileList" :key="index" class="pro-img">
            <img :src="item.fileUrl" alt="" width="100%" />
          </div>
        </template>
        <div class="pro_info" v-if="proData.productName">
          产品名称：{{ proData.productName ? proData.productName : '暂无' }}
        </div>
        <div class="pro_info" v-if="proData.specifications">
          产品规格：{{ proData.specifications ? proData.specifications : '暂无' }}
        </div>
        <div class="pro_info" v-if="companyData.name">
          公司名称：{{ companyData.name ? companyData.name : '暂无' }}
        </div>
        <div class="pro_info" v-if="companyData.manufacturer">
          生产厂家：{{ companyData.manufacturer ? companyData.manufacturer : '暂无' }}
        </div>
        <div class="pro_info" v-if="companyData.client">
          委托方：{{ companyData.client ? companyData.client : '暂无' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../utils/axios'
export default {
  props: ['data'],
  data(){
    return {
      numbers: ['', '', '', '', '', ''],
      load: false,
      isCryptogram: true, // 是否有暗骂
      isShow: true, // 
      isCorrect: true, // 是否正确
      resultData: '',
      proData: '', // 产品信息
      companyData: '', // 公司信息
    }
  },
  created(){
    if(this.data.cryptogram && this.data.cryptogram !== ''){
      this.isCryptogram = true
    }else{
      this.isCryptogram = false
      this.load = true
      this.getData(this.data.code)
    }
  },
  methods: {
    inputHandler (e, index) {
      switch (e.inputType) {
        case 'insertText':
          const inputValue = e.target.value;
          if (inputValue.length > 1) {
            e.target.value = inputValue.slice(-1);
          }
          this.numbers[index] = e.data;
          if (index < this.numbers.length - 1) {
            e.target.parentNode.childNodes[index + 1].focus();
          }
          break;
        case 'deleteContentBackward':
          this.numbers[index] = '';
          if (index !== 0) {
            e.target.parentNode.childNodes[index - 1].focus();
          }
          break;
        case 'insertFromPaste':
          if (e.target.value.length > 1) {
            e.target.value = e.target.value.slice(0, 1);
          }
          break;
        case 'deleteContentForward':
          this.numbers[index] = '';
          break;
      }
    },
    deleteHandler (e, index) {
      if (e.key == 'Backspace') {
        this.numbers[index] = '';
        if (index != 0) {
          setTimeout(() => {
            e.target.parentNode.childNodes[index - 1].focus();
          }, 0);
        }
      }
    },
    submit(){
      let a = this.numbers.join('')
      if(a && a !== '' && a.length == 6){
        this.load = true
        this.getIsCryptogram(this.data, a)
      }else{
        alert('请输入6位验证码!')
      }
    },
    // 暗码验证
    getIsCryptogram(data, a){
      this.isShow = false
      axios.get('/system/electronicAntiCounterfeiting/queryAllByCodeAndCryptogram', { params: {code: data.code, cryptogram: a }} ).then((res)=>{
        if(res.data == 1){
          this.getData(data.code)
        }else{
          this.load = false
          this.isCorrect = false
        }
      })
    },
    onAgain(){
      this.isShow = true
      this.numbers = ['', '', '', '', '', '']
    },
    getData(code){
      axios.get('/system/electronicAntiCounterfeiting/queryAllByCode', { params:{code:code}} ).then((res)=>{
        if(res.code == 200){
          this.load = false
          this.isShow = false
          this.isCorrect = true
          this.resultData = res.data
          this.proData = res.data.electronicAntiProduct
          this.companyData = res.data.electronicAntiCompanyConfiguration
          document.title = res.data.electronicAntiProduct.productName
        }else{
          this.load = false
          this.isShow = true
        }
      })
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: NotoSans;
  src: local(NotoSans),url(../assets/fonts/notoSans.woff2) format("woff2");
  font-display: fallback
}
.container{
  width: 90%;
  margin: 150px auto auto;
}
.section{
  text-align: center;
}
.important_font,.small_font {
  margin-bottom: 10px;
}
.important_font {
  font-size: 18px;
  font-family: NotoSans;
  font-display: fallback;
  font-weight: 700;
}
.small_font {
  font-size: 15px;
}
.input_box {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
.input_box input[type=number] {
  outline: none;
  border: none;
  border-bottom: 2px solid #000;
  text-align: center;
  font-size: 5vw;
  width: 7%;
  margin: 0 5px;
  appearance: none;
  border-radius: 0;
}
.btn_section{
  width: 100%;
  margin-top: 30px;
}
.code_submit{
  width: 100%;
  /* padding: 8px 0; */
}
.btn_black_again{
  text-align: center;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  border: 1px solid #000;
  border-radius: 8px;
  background-color: #000;
  color: #fff;
  padding:10px;
  margin-top: 20px;
}
.btn_black{
  width:auto !important;
  text-align: left;
  padding: 15px 10px 8px 15px !important;
  margin-bottom:0!important;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  /* border: 1px solid #ccc; */
  border-radius: 8px;
  background-color: #fff;
  color: #000;
  
}
.btn_black p{
  font-size:13px;
  line-height: 25px;
  margin-top:15px;
  border-top: 1px solid #ccc;
  padding-top: 10px;
}
.btn_black p span{
  color:#f00;
  font-size:20px;
  padding: 0 5px;
}
.loading{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#fff;
  font-family: NotoSans;
  font-style: italic;
  font-size: 16px;
}
.result_container{
  width: 94%;
  margin: auto;
}
.result_section{
  width: 100%;
  text-align: center;
  margin-bottom: 15px;
}
.pro-img{
  margin-top: 15px;
}
.table{
  width: 100%;
  height: 100%;
  vertical-align: middle;
  text-align: center;
  margin: 100px 0;
}
.content{
  margin-bottom: 30px;
}
.gray_font{
  font-size: 15px;
  color: #4d4d4d;
  margin: 15px 0 5px;
}
.result_section .btn_black{
  width: 100%;
  padding: 8px 0;
  margin-bottom: 10px;
}
.pro_info{
  font-size: 14px;
  color: #4d4d4d;
  margin-top: 15px;
  text-align: left;
  border: 1px solid #8f8f8f;
  border-radius: 8px;
  padding: 10px;
}
</style>
